import React from 'react';
import { BsPatchCheckFill } from 'react-icons/bs';

import './experience.css';

const Experience = () => {
  const frontend = [
    { skill: 'HTML', level: 'Advanced' },
    { skill: 'CSS', level: 'Intermediate' },
    { skill: 'JavaScript', level: 'Advanced' },
    { skill: 'TypeScript', level: 'Intermediate' },
    { skill: 'ReactJS', level: 'Advanced' },
    { skill: 'ReactNative', level: 'Intermediate' },
    { skill: 'Redux', level: 'Advanced' },
    { skill: 'React Query', level: 'Basic' },
    { skill: 'MUI', level: 'Intermediate' },
    { skill: 'BootStrap', level: 'Advanced' },
  ];

  const backend = [
    { skill: 'NodeJS', level: 'Intermediate' },
    { skill: 'ExpressJS', level: 'Advanced' },
    { skill: 'MongoDB', level: 'Advanced' },
    { skill: 'Mongoose', level: 'Advanced' },
    { skill: 'MySQL', level: 'Basic' },
    { skill: 'Sequelize', level: 'Basic' },
    { skill: 'Python', level: 'Basic' },
    { skill: 'Web Scraping', level: 'Intermediate' },
    { skill: 'Socket IO', level: 'Basic' },
    { skill: 'Mongo Aggregation', level: 'Basic' },
  ];

  const renderExperience = ({ skill, level }, i) => (
    <article className="experience__details" key={i}>
      <BsPatchCheckFill className="experience__details-icon" />
      <div>
        <h4>{skill}</h4>
        <small className="text-light">{level}</small>
      </div>
    </article>
  );

  return (
    <section id="experience">
      <h5>The skills I have</h5>
      <h2>My Experience</h2>

      <div className="container experience__container">
        <div className="experience__frontend">
          <h3>Frontend Development</h3>
          <div className="experience__content">
            {frontend.map((experience, i) => renderExperience(experience, i))}
          </div>
        </div>
        <div className="experience__backend">
          <h3>Backend Development</h3>
          <div className="experience__content">
            {backend.map((experience, i) => renderExperience(experience, i))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
